import React from "react";
import { Link } from "react-router-dom";

export default function Evaluated() {
  return (
    <>
      <div className="overflow-hidden py-0 sm:py-0">
        <div className=" mx-auto px-0 lg:px-0">
          <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-0 gap-y-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2 patterns-bg">
            <img
              alt="Get Evaluated by NFL Players"
              src="/players_bg.png"
              width={2432}
              height={1442}
              className="w-[28rem] max-w-none sm:w-[54rem] md:-ml-4 lg:-ml-0"
            />
            <div className="lg:pr-8 lg:pt-4  patterns-bg">
              <div className="relative">
                <div className="grid grid-flow-row auto-rows-max">
                  <div className="mx-auto p-6 sm:px-40 sm:p-24">
                    <p className="text-white uppercase text-4xl md:text-5xl lg:text-left text-center font-black italic ">
                      Get Evaluated by <br /> NFL Players + Universities
                    </p>
                    <p className=" text-white text-xl text-center lg:text-left py-6">
                      Receive genuine evaluation from NFL players, enriched with
                      firsthand experience. At the end of each combine, all
                      information will be shared with universities that endorse
                      Trackit Verified and other universities will be able to
                      actively view athletes' profiles.
                    </p>

                    <div className="mt-6 pb-20 lg:text-left text-center hidden">
                      <Link
                        to={"/register"}
                        className="  rounded-full uppercase bg-transparent border-2 border-white text-white px-12 py-3 hover:bg-white hover:text-black"
                      >
                        Register
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
